import { render } from "./HeaderBottom.vue?vue&type=template&id=ab38f13a&scoped=true"
import script from "./HeaderBottom.vue?vue&type=script&lang=js"
export * from "./HeaderBottom.vue?vue&type=script&lang=js"

import "./HeaderBottom.vue?vue&type=style&index=0&id=ab38f13a&lang=sass&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab38f13a"]])

export default __exports__